module.exports = "https://trybtryb-legacy.web.app/img/to_bottom_right.cb0ead2b.svg";